import ReactTooltip from 'react-tooltip';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter, matchPath } from 'react-router-dom';
import classnames from 'classnames';
import { Modal } from '@pwc/appkit-react/lib/Modal';

import Routes from '../routes';
import { menuTooltipContainerId, menuTypes } from './constants';
import DropdownMenu from '../shared/dropdownMenu';
import DropdownSubMenu from '../shared/dropdownSubMenu.component';
import { MenuLink as Link } from './menuLink.component';
import Trigger from './trigger.component';
import PageHelpModal from './helpMenu/pageHelpModal.component';
import { AuthorizeUserTree, AuthorizedLink, permissions, permissionTypes, assignmentTypes, assignmentPermissions } from '../shared/authorization';

import JobsMenu from './jobsMenu/jobsMenu.component';

import { showSubmitRequestModal } from '../shared/support/submitRequest/store/actions';
import { showScenariosMenuSelector, allowOldTaxExpenseFlagSelector, bsmFlagSelector } from '../shared/store/selectors';
import { isInternalEmailAddress } from '../userSettings/utils';

import getPathnameForHelpContent from './helpMenu/utils/getPathnameForHelpContent';
import { fetchMainPageButtons } from './shared/store/actions';

import UserMenu from './userMenu.component';
import { UserPropTypes } from './shared/proptypes';
import { JobsMenuIcon } from './JobsMenuIcon.component';
import { useIsClientLocked } from '../shared/clientLocked/useIsClientLocked.hook';
import { clientLockedMessages } from '../shared/clientLocked/messages';

class Menu extends PureComponent {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }),
    user: UserPropTypes,
    showSubmitRequestModal: PropTypes.func.isRequired,
    fetchMainPageButtons: PropTypes.func.isRequired,
    showScenariosMenu: PropTypes.bool,
    isClientLocked: PropTypes.bool,
    allowOldTaxExpense: PropTypes.bool,
    bsmFlag: PropTypes.bool,
  };

  state = {
    openedMenu: null,
    helpOpened: false,
    jobsOpened: false,
  };

  onDashboardMenuShow = () => {
    this.setState({
      openedMenu: menuTypes.DASHBOARD,
    });
  };

  onScenariosMenuShow = () => {
    this.setState({
      openedMenu: menuTypes.SCENARIOS,
    });
  };

  onProvisionMenuShow = () => {
    this.setState({
      openedMenu: menuTypes.PROVISION,
    });
  };

  onBalanceSheetMenuShow = () => {
    this.setState({
      openedMenu: menuTypes.BALANCE_SHEET,
    });
  };

  onReportsMenuShow = () => {
    this.setState({
      openedMenu: menuTypes.REPORTS,
    });
  };

  onRTPMenuShow = () => {
    this.setState({
      openedMenu: menuTypes.RETURN_TO_PROVISION,
    });
  };
  onAdministrationMenuShow = () => {
    this.setState({
      openedMenu: menuTypes.ADMINISTRATION,
    });
  };

  onSupportMenuShow = () => {
    this.setState({
      openedMenu: menuTypes.SUPPORT,
    });
  };

  onUserMenuShow = () => {
    this.setState({
      openedMenu: menuTypes.USER,
    });
  };

  onGearMenuShow = () => {
    this.setState({
      openedMenu: menuTypes.GEAR,
    });
  };

  onDashboardMenuHide = () => {
    this.setState(({ openedMenu }) => ({
      openedMenu: openedMenu === menuTypes.DASHBOARD ? null : openedMenu,
    }));
  };

  onScenariosMenuHide = () => {
    this.setState(({ openedMenu }) => ({
      openedMenu: openedMenu === menuTypes.SCENARIOS ? null : openedMenu,
    }));
  };

  onProvisionMenuHide = () => {
    this.setState(({ openedMenu }) => ({
      openedMenu: openedMenu === menuTypes.PROVISION ? null : openedMenu,
    }));
  };

  onBalanceSheetMenuHide = () => {
    this.setState(({ openedMenu }) => ({
      openedMenu: openedMenu === menuTypes.BALANCE_SHEET ? null : openedMenu,
    }));
  };

  onReportsMenuHide = () => {
    this.setState(({ openedMenu }) => ({
      openedMenu: openedMenu === menuTypes.REPORTS ? null : openedMenu,
    }));
  };

  onRTPMenuHide = () => {
    this.setState(({ openedMenu }) => ({
      openedMenu: openedMenu === menuTypes.RETURN_TO_PROVISION ? null : openedMenu,
    }));
  };
  onAdministrationMenuHide = () => {
    this.setState(({ openedMenu }) => ({
      openedMenu: openedMenu === menuTypes.ADMINISTRATION ? null : openedMenu,
    }));
  };

  onSupportMenuHide = () => {
    this.setState(({ openedMenu }) => ({
      openedMenu: openedMenu === menuTypes.SUPPORT ? null : openedMenu,
    }));
  };

  onUserMenuHide = () => {
    this.setState(({ openedMenu }) => ({
      openedMenu: openedMenu === menuTypes.USER ? null : openedMenu,
    }));
  };

  onGearMenuHide = () => {
    this.setState(({ openedMenu }) => ({
      openedMenu: openedMenu === menuTypes.GEAR ? null : openedMenu,
    }));
  };

  toggleHelpModal = () => {
    const { user, fetchMainPageButtons } = this.props;

    if (!this.state.helpOpened && user) {
      fetchMainPageButtons(getPathnameForHelpContent());
    }
    this.setState(prevState => ({
      helpOpened: !prevState.helpOpened,
    }));
  };

  toggleJobsModal = () => {
    this.setState(prevState => ({
      jobsOpened: !prevState.jobsOpened,
    }));
  };

  render() {
    const { openedMenu } = this.state;
    const { pathname } = this.props.location;
    const { user, isClientLocked, allowOldTaxExpense, bsmFlag } = this.props;
    const rtpFlag = user && user.rtpFlag;
    const isPwcUser = user && isInternalEmailAddress(user.email);
    const taxExpenseClasses = classnames('with-separator');
    if (!user || !user.isActive) {
      return (
        <nav className="a-header-wrapper">
          <div className="a-brand-container">
            <Link to="/">
              <div className="a-pwc-logo a-md"/>
            </Link>
            <div className="a-divider"/>
            Tax Lifecycle Solutions
          </div>
          <div className="a-actions-container">
            <button
              className="a-icon-container d-none d-sm-flex a-btn-background-transparent"
              onClick={this.toggleHelpModal}
            >
              <span className="appkiticon icon-help-question-outline"/>
            </button>
            <PageHelpModal
              helpOpened={this.state.helpOpened}
              toggleHelpModal={this.toggleHelpModal}
            />
            <UserMenu
              isOpen={openedMenu === menuTypes.USER}
              user={user}
              onMenuShow={this.onUserMenuShow}
              onMenuHide={this.onUserMenuHide}
            />
          </div>
        </nav>
      );
    }

    return (
      <nav className="a-header-wrapper">
        <ReactTooltip effect="float" id={menuTooltipContainerId} className=""/>

        <div className="a-brand-container">
          <Link to="/">
            <div className="a-pwc-logo a-md" />
          </Link>
          <div className="a-divider"/>
          <DropdownMenu
            trigger={
              <Trigger
                active={openedMenu === menuTypes.DASHBOARD
                  || (!openedMenu && !!matchPath(
                    pathname,
                    { path: Routes.dashboard.MAIN, exact: false }
                  ))}
                linkTo={Routes.dashboard.MAIN}
              >
                Tax Lifecycle Solutions
              </Trigger>
            }
            onShow={this.onDashboardMenuShow}
            onHide={this.onDashboardMenuHide}
            openOnHover
            hideOnClick
          >
            <Link to={Routes.dashboard.CONNECTION_MONITOR}>Connection Health</Link>
            <Link to={Routes.dashboard.CONNECTION_RUN_STATUS}>Connection Run Status</Link>
            <Link to={Routes.dashboard.PROVISION_QUALITY_OVERVIEW}>Provision Quality Overview</Link>
            <Link to={Routes.dashboard.PROVISION_QUALITY_SINGLE}>Provision Quality Detail</Link>
          </DropdownMenu>

          {
            this.props.showScenariosMenu && (
              <Trigger
                active={openedMenu === menuTypes.SCENARIOS
                || (!openedMenu && !!matchPath(
                  pathname,
                  { path: Routes.scenarios.MAIN, exact: false }
                ))}
                linkTo={Routes.scenarios.MAIN}
                onMouseEnter={this.onScenariosMenuShow}
                onMouseLeave={this.onScenariosMenuHide}
              >
                Scenarios
              </Trigger>
            )
          }
          <AuthorizeUserTree
            withAssignments={[{
              assignmentType: assignmentTypes.CC,
              requiredPermission: assignmentPermissions.Adjust,
            }]}
            withPermissions={[{
              permissionType: permissionTypes.VIEW,
              permissionPath: permissions.BATCH_PROVISION,
            }]}
            otherwise={(
              <Trigger
                active={openedMenu === menuTypes.PROVISION
                  || (!openedMenu && !!matchPath(
                    pathname,
                    { path: Routes.provision.MAIN, exact: false }
                  ))}
                linkTo={Routes.provision.MAIN}
                onMouseEnter={this.onProvisionMenuShow}
                onMouseLeave={this.onProvisionMenuHide}
              >
                Tax Provision
              </Trigger>
            )}
            requireBothPermissionsAndAssignments={false}
          >
            <DropdownMenu
              trigger={
                <Trigger
                  active={openedMenu === menuTypes.PROVISION
                    || (!openedMenu && !!matchPath(
                      pathname,
                      { path: Routes.provision.MAIN, exact: false }
                    ))}
                  linkTo={Routes.provision.MAIN}
                >
                  Tax Provision
                </Trigger>
              }
              onShow={this.onProvisionMenuShow}
              onHide={this.onProvisionMenuHide}
              openOnHover
              hideOnClick
            >
              <AuthorizedLink
                withAssignments={[{
                  assignmentType: assignmentTypes.CC,
                  requiredPermission: assignmentPermissions.Adjust,
                }]}
                to={Routes.provision.BATCH_ADJUSTMENTS}
                disabled={isClientLocked}
                disabledReason={clientLockedMessages.BATCH_ADJUSTMENTS_PAGE}
              >
                Batch Adjustments
              </AuthorizedLink>
              <AuthorizedLink
                withPermissions={[{
                  permissionType: permissionTypes.VIEW,
                  permissionPath: permissions.BATCH_PROVISION,
                }]}
                to={Routes.provision.BATCH_PROVISIONS}
              >
                Batch Provisions
              </AuthorizedLink>
            </DropdownMenu>
          </AuthorizeUserTree>

          {
            bsmFlag && (
              <AuthorizeUserTree
                withPermissions={[{
                  permissionType: permissionTypes.VIEW,
                  permissionPath: permissions.BALANCE_SHEET_MANAGEMENT_VIEW,
                }]}
              >
                <DropdownMenu
                  trigger={
                    <Trigger
                      active={openedMenu === menuTypes.BALANCE_SHEET
                            || (!openedMenu && !!matchPath(
                              pathname,
                              { path: Routes.balanceSheetManagement.MAIN, exact: false }
                            ))}
                    >
                      Balance Sheet Management
                    </Trigger>
                  }
                  onShow={this.onBalanceSheetMenuShow}
                  onHide={this.onBalanceSheetMenuHide}
                  openOnHover
                  hideOnClick
                >
                  <AuthorizedLink
                    withPermissions={[{
                      permissionType: permissionTypes.VIEW,
                      permissionPath: permissions.ADD_TAX_ENTRY,
                    }]}
                    to={Routes.balanceSheetManagement.ADD_TAX_ENTRY}
                    disabled={isClientLocked}
                    disabledReason="You are not allowed to add tax entry while the client is locked"
                  >
                    Add Tax Entries
                  </AuthorizedLink>
                  <AuthorizedLink
                    withPermissions={[{
                      permissionType: permissionTypes.VIEW,
                      permissionPath: permissions.BATCH_TAX_ENTRIES,
                    }]}
                    to={Routes.balanceSheetManagement.BATCH_TAX_ENTRIES}
                    disabled={isClientLocked}
                    disabledReason="You are not allowed to batch tax entries while the client is locked"
                  >
                    Batch Tax Entries
                  </AuthorizedLink>
                  <AuthorizedLink
                    withPermissions={[{
                      permissionType: permissionTypes.VIEW,
                      permissionPath: permissions.BATCH_RATE_CHANGE_WORKPAPER,
                    }]}
                    to={Routes.balanceSheetManagement.RATE_CHANGE_WORKPAPER}
                    otherwise={<div className="separator-placeholder" />}
                    listElementClassName="with-separator"
                    disabled={isClientLocked}
                    disabledReason={clientLockedMessages.RATE_CHANGE_WORKPAPER_PAGE}
                  >
                    Rate Change Workpaper
                  </AuthorizedLink>
                  <Link
                    to={Routes.balanceSheetManagement.APPROVE_TAX_ENTRIES}
                  >
                    Approve Tax Entries
                  </Link>
                  <Link
                    to={Routes.balanceSheetManagement.VIEW_TAX_ENTRIES}
                    listElementClassName="with-separator"
                  >
                    View Tax Entries
                  </Link>
                  <Link
                    to={Routes.balanceSheetManagement.VIEW_ACCOUNT_ACTIVITY}
                  >
                    View Account Activity
                  </Link>
                  <Link
                    to={Routes.balanceSheetManagement.VIEW_ACCOUNT_BALANCES}
                  >
                    View BSM Account Balances
                  </Link>
                  <Link
                    to={Routes.balanceSheetManagement.VIEW_DIAGNOSTICS}
                  >
                    View Diagnostics
                  </Link>
                  <Link
                    to={Routes.balanceSheetManagement.VIEW_NOTIFICATIONS}
                  >
                    View Notifications
                  </Link>
                </DropdownMenu>
              </AuthorizeUserTree>
            )
          }

          <DropdownMenu
            trigger={
              <Trigger
                active={openedMenu === menuTypes.REPORTS
                            || (!openedMenu && !!matchPath(
                              pathname,
                              { path: Routes.reports.MAIN, exact: false })
                            )}
              >
                Reports
              </Trigger>
            }
            onShow={this.onReportsMenuShow}
            onHide={this.onReportsMenuHide}
            openOnHover
            hideOnClick
          >
            <Link
              to={Routes.reports.CONFIGURATION_SETTING}
            >
              Configuration
            </Link>
            <AuthorizedLink
              withPermissions={[{
                permissionType: permissionTypes.VIEW,
                permissionPath: permissions.CUSTOM_REPORTS,
              }]}
              to={Routes.reports.CUSTOM_REPORTS}
            >
              Custom Reports
            </AuthorizedLink>

            <Link
              to={Routes.reports.EFFECTIVE_TAX_RATE}
            >
              Effective Tax Rate (ETR)
            </Link>
            <Link
              to={Routes.reports.TAX_EXPENSE_WITH_EXPANDABLE_DETAILS_LIST}
              listElementClassName={taxExpenseClasses}
            >
              Tax Expense
            </Link>
            {allowOldTaxExpense && (
              <Link
                to={Routes.reports.TAX_EXPENSE}
                listElementClassName={taxExpenseClasses}
              >
                Old Tax Expense
              </Link>
            )}
            {
              bsmFlag && (
                <AuthorizeUserTree
                  withPermissions={[{
                    permissionType: permissionTypes.VIEW,
                    permissionPath: permissions.BALANCE_SHEET_MANAGEMENT_VIEW,
                  }]}
                  className="sub-nav-link-nav"
                >
                  <DropdownSubMenu label="Balance Sheet Management">
                    <AuthorizedLink
                      to={Routes.reports.VIEW_DEFERRED_ROLLFORWARD}
                    >
                      Deferred Rollforward
                    </AuthorizedLink>
                    <AuthorizedLink
                      to={Routes.reports.VIEW_TAX_LIFECYCLE}
                    >
                      Tax Lifecycle
                    </AuthorizedLink>
                    <AuthorizedLink
                      to={Routes.reports.VIEW_TAX_RESERVES}
                    >
                      Tax Reserves
                    </AuthorizedLink>
                  </DropdownSubMenu>
                </AuthorizeUserTree>
              )
            }
            <AuthorizedLink
              withPermissions={[{
                permissionType: permissionTypes.VIEW,
                permissionPath: permissions.CUSTOM_REPORTS,
              }]}
              to={Routes.reports.BATCH_REPORTS}
            >
              Batch Reports
            </AuthorizedLink>
            {isPwcUser && (
              <Link
                to={Routes.reports.MULTI_PERIOD_ANALYSIS}
              >
                Multi-Period Analysis
              </Link>
            )}
          </DropdownMenu>
          {
            rtpFlag && (
              <Trigger
                active={openedMenu === menuTypes.RETURN_TO_PROVISION
                    || (!openedMenu && !!matchPath(
                      pathname,
                      { path: Routes.returnToProvision.MAIN, exact: false }
                    ))}
                linkTo={Routes.returnToProvision.MAIN}
                onMouseEnter={this.onRTPMenuShow}
                onMouseLeave={this.onRTPMenuHide}
              >
                Return to Provision
              </Trigger>
            )
          }
          <DropdownMenu
            trigger={
              <Trigger
                active={openedMenu === menuTypes.ADMINISTRATION
                            || (!openedMenu && !!matchPath(
                              pathname,
                              { path: Routes.administration.MAIN, exact: false })
                            )}
              >
                Administration
              </Trigger>
            }
            onShow={this.onAdministrationMenuShow}
            onHide={this.onAdministrationMenuHide}
            openOnHover
            hideOnClick
          >
            <Link
              to={Routes.administration.BEGINNING_BALANCES}
            >
              Beginning Balances
            </Link>

            <Link
              to={Routes.administration.BOOK_TO_TAX_DIFFERENCE}
            >
              Book To Tax Differences
            </Link>

            <Link
              to={Routes.administration.BUSINESS_UNIT_SETTINGS}
            >
              Business Units
            </Link>

            <AuthorizedLink
              withPermissions={[{
                permissionType: permissionTypes.VIEW,
                permissionPath: permissions.CATEGORIES_AND_TAGS,
              }]}
              className="sub-nav-link"
              to={Routes.administration.CATEGORIES_AND_TAGS}
            >
              Categories and Tags
            </AuthorizedLink>

            <AuthorizedLink
              withPermissions={[{
                permissionType: permissionTypes.VIEW,
                permissionPath: permissions.CHART_OF_ACCOUNTS,
              }]}
              to={Routes.administration.CHART_OF_ACCOUNTS}
            >
              Chart of Accounts
            </AuthorizedLink>
            <Link
              to={Routes.administration.COMPANY_CODES}
            >
              Company Codes
            </Link>
            <AuthorizedLink
              to={Routes.administration.CURRENCY_CONVERSION_RATES}
            >
              Currency Conversion Rates
            </AuthorizedLink>
            <Link
              to={Routes.administration.CUSTOM_GROUPS}
            >
              Custom Groups
            </Link>

            <Link
              to={Routes.administration.LEGAL_ENTITY_SETTINGS}
            >
              Legal Entities
            </Link>

            <Link
              to={Routes.administration.OBLIGATIONS}
            >
              Obligations
            </Link>

            <Link
              to={Routes.administration.TAX_ACCOUNTING_SETTINGS}
            >
              Tax Accounting
            </Link>
            <Link
              className="sub-nav-link"
              to={Routes.administration.TAX_BOOKING_ENTITIES}
            >
              Tax Booking Entities (TBE)
            </Link>
            <Link
              to={Routes.administration.TAX_RATES}
            >
              Tax Rates
            </Link>
            <Link
              to={Routes.administration.TLS_ACCOUNT_SETTINGS}
            >
              TLS Accounts
            </Link>
            <Link
              to={Routes.administration.TRIAL_BALANCE_THRESHOLD}
            >
              Trial Balance Out of Balance Threshold
            </Link>
            <AuthorizedLink
              withPermissions={[{
                permissionType: permissionTypes.VIEW,
                permissionPath: permissions.DIAGNOSTICS,
              }]}
              to={Routes.administration.DIAGNOSTICS}
            >
              View Diagnostics
            </AuthorizedLink>
            <AuthorizeUserTree
              withPermissions={[{
                permissionType: permissionTypes.VIEW,
                permissionPath: permissions.USER_ADMINISTRATION,
              }]}
              className="sub-nav-link-nav"
              to={Routes.administration.USER_SETTINGS}
            >
              <DropdownSubMenu label="User Administration">

                <AuthorizedLink
                  withPermissions={[{
                    permissionType: permissionTypes.VIEW,
                    permissionPath: permissions.USER_ADMINISTRATION,
                  }]}
                  className="sub-nav-link"
                  to={Routes.administration.USER_SETTINGS}
                >
                  Users and Privileges
                </AuthorizedLink>
                <AuthorizedLink
                  withPermissions={[{
                    permissionType: permissionTypes.VIEW,
                    permissionPath: permissions.USER_ADMINISTRATION,
                  }]}
                  className="sub-nav-link"
                  to={Routes.administration.USER_EXPIRATION}
                >
                  User Expiration
                </AuthorizedLink>

                <AuthorizedLink
                  withPermissions={[{
                    permissionType: permissionTypes.VIEW,
                    permissionPath: permissions.USER_ADMINISTRATION,
                  }]}
                  className="sub-nav-link"
                  to={Routes.administration.ROLES}
                >
                  Roles
                </AuthorizedLink>
              </DropdownSubMenu>
            </AuthorizeUserTree>

            <AuthorizedLink
              className="sub-nav-link"
              to={Routes.administration.CLIENT_ADMINISTRATION}
              withPermissions={[{
                permissionType: permissionTypes.VIEW,
                permissionPath: permissions.CLIENT_ADMININISTRATION,
              }]}
            >
              Client Administration
            </AuthorizedLink>

            <AuthorizedLink
              withPermissions={[{
                permissionType: permissionTypes.VIEW,
                permissionPath: permissions.DATABASE_LOGS,
              }]}
              className="sub-nav-link"
              to={Routes.administration.DATABASE_LOGS}
            >
              Database Logs
            </AuthorizedLink>

            <AuthorizedLink
              withPermissions={[{
                permissionType: permissionTypes.VIEW,
                permissionPath: permissions.E2E_HEALTHCHECK,
              }]}
              className="sub-nav-link"
              to={Routes.administration.E2E_HEALTHCHECK}
            >
              E2E Healthcheck
            </AuthorizedLink>

            <AuthorizeUserTree
              withPermissions={[{
                permissionType: permissionTypes.VIEW,
                permissionPath: permissions.APPLICATION_ADMINISTRATION,
              }]}
            >
              <DropdownSubMenu label="Application Administration">

                <AuthorizedLink
                  withPermissions={[{
                    permissionType: permissionTypes.VIEW,
                    permissionPath: permissions.APPLICATION_SETTINGS,
                  }]}
                  className="sub-nav-link"
                  to={Routes.administration.APPLICATION_SETTINGS}
                >
                  Application Settings
                </AuthorizedLink>

                <AuthorizedLink
                  withPermissions={[{
                    permissionType: permissionTypes.VIEW,
                    permissionPath: permissions.CLIENT,
                  }]}
                  to={Routes.administration.CLIENT}
                >
                  Clients
                </AuthorizedLink>

                <AuthorizedLink
                  withPermissions={[{
                    permissionType: permissionTypes.MODIFY,
                    permissionPath: permissions.COMMUNICATIONS,
                  }]}
                  className="sub-nav-link"
                  to={Routes.administration.COMMUNICATIONS_MANAGEMENT}
                >
                  Communications Management
                </AuthorizedLink>

                <AuthorizedLink
                  withPermissions={[{
                    permissionType: permissionTypes.VIEW,
                    permissionPath: permissions.CUSTOM_REPORTS_MANAGEMENT,
                  }]}
                  className="sub-nav-link"
                  to={Routes.administration.CUSTOM_REPORTS_MANAGEMENT}
                >
                  Custom Reports Management
                </AuthorizedLink>

                <AuthorizedLink
                  withPermissions={[{
                    permissionType: permissionTypes.VIEW,
                    permissionPath: permissions.APPLICATION_SETTINGS,
                  }]}
                  className="sub-nav-link"
                  to={Routes.administration.ADMIN_IMPORT}
                >
                  Admin Import
                </AuthorizedLink>
              </DropdownSubMenu>
            </AuthorizeUserTree>

            {
              bsmFlag && (
                <AuthorizeUserTree
                  withPermissions={[{
                    permissionType: permissionTypes.VIEW,
                    permissionPath: permissions.BALANCE_SHEET_MANAGEMENT_ADMIN,
                  }]}
                >
                  <DropdownSubMenu label="Balance Sheet Management">
                    <AuthorizedLink
                      withPermissions={[{
                        permissionType: permissionTypes.VIEW,
                        permissionPath: permissions.SL_ACCOUNTS_PAGE,
                      }]}
                      className="sub-nav-link"
                      to={Routes.administration.SL_ACCOUNTS_PAGE}
                    >
                      Account
                    </AuthorizedLink>
                    <AuthorizedLink
                      withPermissions={[{
                        permissionType: permissionTypes.VIEW,
                        permissionPath: permissions.ACCOUNT_MAP_PAGE,
                      }]}
                      className="sub-nav-link"
                      to={Routes.administration.ACCOUNT_MAP}
                    >
                      Account Map
                    </AuthorizedLink>
                    <AuthorizedLink
                      withPermissions={[{
                        permissionType: permissionTypes.VIEW,
                        permissionPath: permissions.GL_ACCOUNT_LIST_PAGE,
                      }]}
                      className="sub-nav-link"
                      to={Routes.administration.GL_ACCOUNT_LIST}
                    >
                      GL Account List
                    </AuthorizedLink>
                    <AuthorizedLink
                      withPermissions={[{
                        permissionType: permissionTypes.VIEW,
                        permissionPath: permissions.GL_JOURNALS_PAGE,
                      }]}
                      className="sub-nav-link"
                      to={Routes.administration.GL_JOURNALS}
                    >
                      GL Journal
                    </AuthorizedLink>
                    <AuthorizedLink
                      withPermissions={[{
                        permissionType: permissionTypes.VIEW,
                        permissionPath: permissions.ADMIN_TAX_ENTRY,
                      }]}
                      className="sub-nav-link"
                      to={Routes.administration.ADMIN_TAX_ENTRY}
                    >
                      Tax Entry
                    </AuthorizedLink>
                  </DropdownSubMenu>
                </AuthorizeUserTree>
              )
            }
          </DropdownMenu>
        </div>

        <div className="a-actions-container">
          <button
            className="a-icon-container d-none d-sm-flex a-btn-background-transparent"
            onClick={this.toggleJobsModal}
          >
            <JobsMenuIcon/>
          </button>
          <Modal
            className="page-jobs-wrapper"
            visible={this.state.jobsOpened}
            onCancel={this.toggleJobsModal}
            zIndex={90000}
          >
            <JobsMenu
              toggleJobsModal={this.toggleJobsModal}
              isVisible={this.state.jobsOpened}
            />
          </Modal>
          <button
            className="a-icon-container d-none d-sm-flex a-btn-background-transparent"
            id="new-help-pendo-indicator"
          >
            <span className="appkiticon icon-help-question-outline help-question-pendo" />
          </button>
          <button
            className="a-icon-container d-none d-sm-flex a-btn-background-transparent"
            onClick={this.toggleHelpModal}
          >
            <span className="appkiticon icon-help-question-outline" />
          </button>
          <PageHelpModal
            helpOpened={this.state.helpOpened}
            toggleHelpModal={this.toggleHelpModal}
          />
          <UserMenu
            isOpen={openedMenu === menuTypes.USER}
            user={user}
            onMenuShow={this.onUserMenuShow}
            onMenuHide={this.onUserMenuHide}
          />
        </div>
      </nav>
    );
  }
}

const MenuWithClientLockedInfo = props => {
  const isClientLocked = useIsClientLocked();

  return (
    <Menu
      {...props}
      isClientLocked={isClientLocked}
    />
  );
};

function mapStateToProps(state) {
  return {
    user: state.user.user,
    showScenariosMenu: showScenariosMenuSelector(state),
    allowOldTaxExpense: allowOldTaxExpenseFlagSelector(state),
    bsmFlag: bsmFlagSelector(state),
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    showSubmitRequestModal,
    fetchMainPageButtons,
  }
)(MenuWithClientLockedInfo));
